import { useEffect, useState, useMemo } from 'react';
import TecnicosTabs from '../components/TecnicosTabs.jsx';
import { feriados, tecnicos, plantoes } from '../lib/api.js';


// Formata uma data 'YYYY-MM-DD' ou 'YYYY-MM-DDTHH:MM:SS' em DD/MM/YYYY
// Robusto a timezone (não usa Date pra não mexer com offset)
function formatarDataBR(s) {
  if (!s) return '';
  const m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return s;
  return `${m[3]}/${m[2]}/${m[1]}`;
}
// Extrai 'YYYY-MM-DD' de qualquer formato (também faz fallback)
function ymdSomente(s) {
  if (!s) return '';
  const m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})/);
  return m ? m[0] : String(s).slice(0, 10);
}

const TIPO_INFO = {
  nacional:    { cor: '#dc2626', label: '🇧🇷 Nacional' },
  estadual:    { cor: '#1e6fc8', label: '🏛️ Estadual' },
  municipal:   { cor: '#16a34a', label: '🏘️ Municipal' },
  facultativo: { cor: '#9333ea', label: '📅 Facultativo' },
  empresa:     { cor: '#ea580c', label: '🏢 Empresa' },
};

export default function EscalasPage() {
  const [aba, setAba] = useState('feriados');

  return (
    <div className="stack">
      <div className="row between" style={{ alignItems: 'center' }}>
        <h2 style={{ margin: 0 }}>📋 Escalas</h2>
      </div>

      <div style={{
        display: 'flex', gap: 4, padding: 4,
        background: '#f3f4f6', borderRadius: 10, width: 'fit-content',
      }}>
        <BotaoAba ativo={aba === 'feriados'} onClick={() => setAba('feriados')}>
          🎉 Feriados e Escalas Especiais
        </BotaoAba>
        <BotaoAba ativo={aba === 'plantao'} onClick={() => setAba('plantao')}>
          📞 Plantão Diário
        </BotaoAba>
      </div>

      {aba === 'feriados' && <AbaFeriados/>}
      {aba === 'plantao'  && <AbaPlantaoDiario/>}
    </div>
  );
}

function BotaoAba({ ativo, onClick, children }) {
  return (
    <button onClick={onClick} type="button"
      style={{
        border: 'none', background: ativo ? '#fff' : 'transparent',
        color: ativo ? '#F15D22' : '#6b7280',
        padding: '8px 16px', borderRadius: 7, cursor: 'pointer',
        fontWeight: ativo ? 700 : 500, fontSize: '0.85rem',
        boxShadow: ativo ? '0 1px 3px #0001' : 'none',
        transition: 'all 0.15s',
      }}>
      {children}
    </button>
  );
}

function AbaFeriados() {
  const [lista, setLista] = useState([]);
  const [tecsLista, setTecsLista] = useState([]);
  const [ano, setAno] = useState(new Date().getFullYear());
  const [erro, setErro] = useState(null);
  const [carregando, setCarregando] = useState(true);
  const [feriadoEditando, setFeriadoEditando] = useState(null);
  const [feriadoPlantao, setFeriadoPlantao] = useState(null); // feriado selecionado pra escalar plantão

  useEffect(() => { carregar(); }, [ano]);

  async function carregar() {
    setCarregando(true);
    try {
      const [f, t] = await Promise.all([
        feriados.list({ ano }),
        tecnicos.list({ ativo: 'true', limit: 200 }),
      ]);
      setLista(f.data || []);
      setTecsLista(t.data || []);
      setErro(null);
    } catch (e) {
      setErro(e.uiMessage || 'Erro ao carregar');
    } finally { setCarregando(false); }
  }

  const hoje = new Date().toLocaleDateString('en-CA', { timeZone: 'America/Sao_Paulo' });

  return (
    <div className="stack">
      <TecnicosTabs />
      {erro && <div className="card error">{erro}</div>}

      <div className="row between">
        <h2 style={{ margin: 0 }}>Feriados {ano}</h2>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          <select value={ano} onChange={e => setAno(Number(e.target.value))} style={{ width: 'auto' }}>
            {[2026, 2027, 2028].map(a => <option key={a} value={a}>{a}</option>)}
          </select>
          <button className="btn small" onClick={() => setFeriadoEditando({ tipo: 'nacional', recorrente: false, ativo: true })}>
            + Novo feriado
          </button>
        </div>
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        <table style={{ width: '100%', fontSize: '0.85rem' }}>
          <thead>
            <tr>
              <th>Data</th>
              <th>Dia</th>
              <th>Nome</th>
              <th>Tipo</th>
              <th>Cidade/Estado</th>
              <th>Escala</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {lista.map(f => {
              const dataFormatada = new Date(ymdSomente(f.data) + 'T12:00:00').toLocaleDateString('pt-BR', { weekday: 'short' });
              const passado = ymdSomente(f.data) < hoje;
              const tipoInfo = TIPO_INFO[f.tipo] || TIPO_INFO.nacional;
              return (
                <tr key={f.id} style={{ opacity: passado ? 0.45 : 1 }}>
                  <td><strong>{formatarDataBR(f.data)}</strong></td>
                  <td className="muted">{dataFormatada}</td>
                  <td>
                    {f.nome}
                    {f.recorrente && <span className="muted" style={{ fontSize: '0.7rem', marginLeft: 6 }}>♻️ recorrente</span>}
                  </td>
                  <td>
                    <span style={{
                      fontSize: '0.7rem', fontWeight: 600,
                      padding: '2px 8px', borderRadius: 10,
                      background: tipoInfo.cor + '20', color: tipoInfo.cor,
                    }}>{tipoInfo.label}</span>
                  </td>
                  <td>
                    <div className="muted" style={{ fontSize: '0.75rem' }}>
                      {[f.cidade, f.estado].filter(Boolean).join('/') || '—'}
                    </div>
                    {f.afetados_count != null && (
                      <div style={{ fontSize: '0.7rem', color: f.afetados_count === 0 ? '#9ca3af' : '#1e40af', fontWeight: 500 }}
                           title={(f.tecnicos_afetados || []).map(t => t.apelido).join(', ')}>
                        {f.tipo === 'municipal'
                          ? `Afeta ${f.afetados_count} técnico${f.afetados_count !== 1 ? 's' : ''}`
                          : f.tipo === 'estadual'
                            ? `Afeta ${f.afetados_count} técnico${f.afetados_count !== 1 ? 's' : ''} no ${f.estado || '—'}`
                            : `Afeta todos (${f.afetados_count})`}
                      </div>
                    )}
                  </td>
                  <td>
                    <button className="btn small secondary"
                      onClick={() => setFeriadoPlantao(f)}
                      style={{ padding: '0.2rem 0.6rem', fontSize: '0.75rem' }}>
                      ⚙️ Escala
                    </button>
                  </td>
                  <td style={{ display: 'flex', gap: '0.3rem', justifyContent: 'flex-end' }}>
                    <button className="btn small secondary"
                      onClick={() => setFeriadoEditando(f)}
                      style={{ padding: '0.2rem 0.6rem', fontSize: '0.75rem' }}>
                      Editar
                    </button>
                    <button className="btn small"
                      onClick={async () => {
                        if (!confirm(`Excluir "${f.nome}" (${f.data})?`)) return;
                        await feriados.remove(f.id);
                        carregar();
                      }}
                      style={{ padding: '0.2rem 0.6rem', fontSize: '0.75rem', background: '#dc2626' }}>
                      Excluir
                    </button>
                  </td>
                </tr>
              );
            })}
            {lista.length === 0 && !carregando && (
              <tr><td colSpan={7} className="muted" style={{ padding: '1rem', textAlign: 'center' }}>
                Nenhum feriado cadastrado em {ano}
              </td></tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Modal editar */}
      {feriadoEditando && (
        <ModalFeriado
          feriado={feriadoEditando}
          onFechar={() => setFeriadoEditando(null)}
          onSalvo={() => { setFeriadoEditando(null); carregar(); }}
        />
      )}

      {/* Modal plantão */}
      {feriadoPlantao && (
        <ModalPlantao
          feriado={feriadoPlantao}
          tecnicos={tecsLista}
          onFechar={() => setFeriadoPlantao(null)}
          onMudou={carregar}
        />
      )}
    </div>
  );
}

// ─── Modal de edição de feriado ────────────────────────────────
function ModalFeriado({ feriado: f0, onFechar, onSalvo }) {
  const [f, setF] = useState({ ...f0 });
  const [salvando, setSalvando] = useState(false);
  const novo = !f0.id;

  function set(k, v) { setF(prev => ({ ...prev, [k]: v })); }

  async function salvar() {
    setSalvando(true);
    try {
      const body = {
        data: f.data, nome: f.nome, tipo: f.tipo,
        cidade: f.cidade || null, estado: f.estado || null,
        recorrente: !!f.recorrente, ativo: f.ativo !== false,
        observacoes: f.observacoes || null,
      };
      if (novo) await feriados.create(body);
      else await feriados.update(f.id, body);
      onSalvo();
    } catch (e) {
      alert('Erro: ' + (e.uiMessage || e.message));
    } finally { setSalvando(false); }
  }

  return (
    <div onClick={onFechar} style={modalBgStyle}>
      <div onClick={ev => ev.stopPropagation()} style={modalBoxStyle}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem' }}>
          <h3 style={{ margin: 0 }}>{novo ? 'Novo feriado' : 'Editar feriado'}</h3>
          <button onClick={onFechar} style={btnFechar}>×</button>
        </div>

        <div className="stack" style={{ gap: '0.6rem' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.5rem' }}>
            <div>
              <label style={lbl}>Data *</label>
              <input type="date" value={f.data || ''} onChange={e => set('data', e.target.value)} style={inp}/>
            </div>
            <div>
              <label style={lbl}>Tipo *</label>
              <select value={f.tipo || 'nacional'} onChange={e => set('tipo', e.target.value)} style={inp}>
                {Object.entries(TIPO_INFO).map(([k, v]) => (
                  <option key={k} value={k}>{v.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div>
            <label style={lbl}>Nome do feriado *</label>
            <input type="text" value={f.nome || ''} onChange={e => set('nome', e.target.value)}
              placeholder="Ex: Aniversário da Mais Internet" style={inp}/>
          </div>

          {(f.tipo === 'municipal' || f.tipo === 'estadual') && (
            <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: '0.5rem' }}>
              <div>
                <label style={lbl}>Cidade</label>
                <input type="text" value={f.cidade || ''} onChange={e => set('cidade', e.target.value)}
                  placeholder="Ex: Palhoça" style={inp}/>
              </div>
              <div>
                <label style={lbl}>Estado</label>
                <input type="text" value={f.estado || ''} onChange={e => set('estado', e.target.value.toUpperCase().slice(0,2))}
                  placeholder="SC" maxLength={2} style={inp}/>
              </div>
            </div>
          )}

          <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: '0.85rem' }}>
            <input type="checkbox" checked={!!f.recorrente}
              onChange={e => set('recorrente', e.target.checked)} style={{ width: 'auto' }}/>
            Repete todo ano nesta data (♻️)
          </label>

          <div>
            <label style={lbl}>Observações</label>
            <textarea value={f.observacoes || ''} onChange={e => set('observacoes', e.target.value)}
              rows={2} style={{ ...inp, resize: 'vertical' }}/>
          </div>
        </div>

        <div style={{ display: 'flex', gap: '0.5rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
          <button className="btn secondary" onClick={onFechar} disabled={salvando}>Cancelar</button>
          <button className="btn" onClick={salvar} disabled={salvando || !f.data || !f.nome}>
            {salvando ? 'Salvando...' : '💾 Salvar'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Modal de plantão (escalar técnicos pro feriado) ───────────
function ModalPlantao({ feriado, tecnicos: lista, onFechar, onMudou }) {
  const [plantoes, setPlantoes] = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => { carregarPlantoes(); }, [feriado.id]);

  async function carregarPlantoes() {
    setCarregando(true);
    try {
      const r = await feriados.doDia(ymdSomente(feriado.data));
      const f = (r.data || []).find(x => x.id === feriado.id);
      setPlantoes(f?.plantoes || []);
    } finally { setCarregando(false); }
  }

  const tecsNoPlantao = useMemo(() => {
    const map = {};
    for (const p of plantoes) map[String(p.tecnico_id)] = p;
    return map;
  }, [plantoes]);

  async function togglePlantao(tec) {
    const ja = tecsNoPlantao[String(tec.id)];
    setSalvando(true);
    try {
      if (ja) {
        await feriados.removePlantao(feriado.id, tec.id);
      } else {
        await feriados.setPlantao(feriado.id, tec.id, {
          horario_inicio: tec.horario_inicio?.slice(0,5) || '08:00',
          horario_fim:    tec.horario_fim?.slice(0,5)    || '18:00',
        });
      }
      await carregarPlantoes();
      onMudou?.();
    } catch (e) {
      alert('Erro: ' + (e.uiMessage || e.message));
    } finally { setSalvando(false); }
  }

  async function ajustarHorario(tecnicoId, campo, valor) {
    const p = tecsNoPlantao[String(tecnicoId)];
    if (!p) return;
    setSalvando(true);
    try {
      await feriados.setPlantao(feriado.id, tecnicoId, {
        horario_inicio: campo === 'inicio' ? valor : p.horario_inicio.slice(0,5),
        horario_fim:    campo === 'fim'    ? valor : p.horario_fim.slice(0,5),
      });
      await carregarPlantoes();
    } finally { setSalvando(false); }
  }

  return (
    <div onClick={onFechar} style={modalBgStyle}>
      <div onClick={ev => ev.stopPropagation()} style={{ ...modalBoxStyle, maxWidth: 700, maxHeight: '85vh', overflow: 'auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
          <div>
            <h3 style={{ margin: 0 }}>Escala · {feriado.nome}</h3>
            <div className="muted" style={{ fontSize: '0.8rem' }}>
              {formatarDataBR(feriado.data)}
              {' · '}
              <strong>{plantoes.length}</strong> técnico{plantoes.length !== 1 ? 's' : ''} escalado{plantoes.length !== 1 ? 's' : ''}
            </div>
          </div>
          <button onClick={onFechar} style={btnFechar}>×</button>
        </div>

        <div className="muted" style={{ fontSize: '0.8rem', marginBottom: '0.75rem', padding: '0.5rem', background: '#fef3c7', borderRadius: 4 }}>
          ℹ️ <strong>Padrão:</strong> em feriado <strong>ninguém trabalha</strong>. Marque abaixo apenas quem trabalhará e o horário customizado de cada um.
        </div>

        {carregando ? (
          <div className="muted" style={{ padding: '1rem', textAlign: 'center' }}>Carregando...</div>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: '1fr', gap: '0.3rem' }}>
            {lista.map(tec => {
              const p = tecsNoPlantao[String(tec.id)];
              const ativo = !!p;
              return (
                <div key={tec.id} style={{
                  display: 'flex', alignItems: 'center', gap: '0.6rem',
                  padding: '0.5rem 0.7rem',
                  background: ativo ? '#dcfce7' : '#fafafa',
                  border: `1px solid ${ativo ? '#16a34a' : 'var(--cinza-borda)'}`,
                  borderRadius: 4,
                  opacity: salvando ? 0.6 : 1,
                }}>
                  <input type="checkbox" checked={ativo} onChange={() => togglePlantao(tec)} disabled={salvando}
                    style={{ width: 'auto', margin: 0, cursor: 'pointer' }}/>
                  <div style={{ flex: 1, fontSize: '0.85rem' }}>
                    <strong>{tec.apelido || tec.nome.split(' ')[0]}</strong>
                    {tec.is_terceirizado && <span style={{ fontSize: '0.65rem', marginLeft: 6, background: '#fef3c7', color: '#92400e', padding: '0px 4px', borderRadius: 3 }}>PJ</span>}
                    <span className="muted" style={{ fontSize: '0.75rem', marginLeft: 6 }}>
                      {tec.unidade_negocio || '(sem unidade)'} · jornada normal {tec.horario_inicio?.slice(0,5)}-{tec.horario_fim?.slice(0,5)}
                    </span>
                  </div>
                  {ativo && (
                    <div style={{ display: 'flex', gap: '0.3rem', alignItems: 'center' }}>
                      <input type="time"
                        value={p.horario_inicio?.slice(0,5) || ''}
                        onChange={e => ajustarHorario(tec.id, 'inicio', e.target.value)}
                        disabled={salvando}
                        style={{ width: 90 }}/>
                      <span>–</span>
                      <input type="time"
                        value={p.horario_fim?.slice(0,5) || ''}
                        onChange={e => ajustarHorario(tec.id, 'fim', e.target.value)}
                        disabled={salvando}
                        style={{ width: 90 }}/>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem' }}>
          <button className="btn" onClick={onFechar}>Fechar</button>
        </div>
      </div>
    </div>
  );
}

// ─── Estilos compartilhados ────────────────────────────────────
const modalBgStyle = {
  position: 'fixed', inset: 0, background: '#0008',
  display: 'flex', alignItems: 'center', justifyContent: 'center',
  zIndex: 1000,
};
const modalBoxStyle = {
  background: '#fff', borderRadius: 8,
  padding: '1.5rem', minWidth: 420, maxWidth: 560,
  boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
};
const btnFechar = {
  background: 'none', border: 'none', fontSize: '1.5rem',
  cursor: 'pointer', color: '#6b7280',
};
const lbl = { fontSize: '0.8rem', fontWeight: 500, display: 'block', marginBottom: 2 };
const inp = { width: '100%' };

// =====================================================================
// ABA: Plantão Diário (técnicos à disposição em casa)
// =====================================================================

function AbaPlantaoDiario() {
  const [lista, setLista]         = useState([]);
  const [tecs, setTecs]           = useState([]);
  const [carregando, setCarregando] = useState(true);
  const [erro, setErro]           = useState('');
  const [periodo, setPeriodo]     = useState(() => {
    const hoje = new Date();
    const fim = new Date(hoje);
    fim.setDate(fim.getDate() + 30);
    return { inicio: hoje.toISOString().slice(0,10), fim: fim.toISOString().slice(0,10) };
  });
  const [mostrarModal, setMostrarModal] = useState(null); // null | { modo: 'novo' | 'intervalo' }

  async function carregar() {
    setCarregando(true);
    setErro('');
    try {
      const [pl, ts] = await Promise.all([
        plantoes.lista(periodo.inicio, periodo.fim),
        tecnicos.list({ ativo: 'true', limit: 200 }),
      ]);
      setLista(pl || []);
      setTecs(ts.data || []);
    } catch (e) {
      setErro(e.uiMessage || e.message || 'Falha ao carregar');
    } finally {
      setCarregando(false);
    }
  }

  useEffect(() => { carregar(); }, [periodo]);

  async function removerPlantao(id) {
    if (!confirm('Remover este plantão?')) return;
    try {
      await plantoes.remover(id);
      carregar();
    } catch (e) {
      alert('Falha ao remover: ' + (e.uiMessage || e.message));
    }
  }

  // Agrupa por data
  const porData = {};
  for (const p of lista) {
    if (!porData[p.data]) porData[p.data] = [];
    porData[p.data].push(p);
  }
  const datasOrdenadas = Object.keys(porData).sort();

  return (
    <>
      {mostrarModal && (
        <ModalPlantaoDiario
          modo={mostrarModal.modo}
          tecnicos={tecs}
          onFechar={() => setMostrarModal(null)}
          onSalvo={() => { setMostrarModal(null); carregar(); }}
        />
      )}

      <div className="card" style={{
        background: '#FDEBE3', borderLeft: '4px solid #F15D22',
        padding: '12px 16px', fontSize: '0.85rem',
      }}>
        <strong>📞 Plantão Diário:</strong> técnicos em casa, à disposição para imprevistos
        (chamadas fora do horário comercial, fins de semana, feriados).
        Não substitui a escala normal — é uma camada adicional de pronto-socorro.
      </div>

      <div className="card row" style={{ alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
          <span className="muted" style={{ fontSize: '0.8rem' }}>Período:</span>
          <input type="date" value={periodo.inicio}
            onChange={e => setPeriodo(p => ({ ...p, inicio: e.target.value }))}
            style={{ width: 140 }}/>
          <span className="muted">→</span>
          <input type="date" value={periodo.fim}
            onChange={e => setPeriodo(p => ({ ...p, fim: e.target.value }))}
            style={{ width: 140 }}/>
        </div>
        <div style={{ flex: 1 }}/>
        <button className="btn small" onClick={() => setMostrarModal({ modo: 'novo' })}>
          + Adicionar plantão
        </button>
        <button className="btn small secondary" onClick={() => setMostrarModal({ modo: 'intervalo' })}>
          🗓 Plantão recorrente
        </button>
      </div>

      {erro && <div className="card error">{erro}</div>}

      {carregando ? (
        <div className="card muted" style={{ padding: '2rem', textAlign: 'center' }}>Carregando...</div>
      ) : datasOrdenadas.length === 0 ? (
        <div className="card muted" style={{ padding: '2rem', textAlign: 'center' }}>
          📭 Nenhum plantão cadastrado neste período. Use os botões acima para adicionar.
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
          {datasOrdenadas.map(data => {
            const diaSemana = new Date(data + 'T12:00:00').toLocaleDateString('pt-BR', { weekday: 'long' });
            const hoje = new Date().toISOString().slice(0,10);
            const isHoje = data === hoje;
            return (
              <div key={data} className="card" style={{
                padding: '12px 16px',
                background: isHoje ? '#fef3c7' : '#fff',
                borderLeft: isHoje ? '4px solid #f59e0b' : '4px solid #e5e7eb',
              }}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, marginBottom: 8 }}>
                  <strong style={{ fontSize: '1rem' }}>{formatarDataBR(data)}</strong>
                  <span className="muted" style={{ fontSize: '0.8rem', textTransform: 'capitalize' }}>{diaSemana}</span>
                  {isHoje && <span style={{
                    fontSize: '0.65rem', fontWeight: 700, background: '#f59e0b', color: '#fff',
                    padding: '2px 8px', borderRadius: 4,
                  }}>HOJE</span>}
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {porData[data].map(p => (
                    <div key={p.id} style={{
                      display: 'flex', alignItems: 'center', gap: 8,
                      padding: '6px 10px', borderRadius: 8,
                      background: '#f9fafb', border: '1px solid #e5e7eb',
                      fontSize: '0.8rem',
                    }}>
                      <span style={{ fontWeight: 600 }}>{p.tecnico_apelido || p.tecnico_nome}</span>
                      <span className="muted">{p.horario_inicio}–{p.horario_fim}</span>
                      {p.contato_emergencia && (
                        <span title="Contato de emergência" style={{ fontSize: '0.7rem', color: '#16a34a' }}>
                          📱 {p.contato_emergencia}
                        </span>
                      )}
                      <button onClick={() => removerPlantao(p.id)}
                        style={{
                          background: 'none', border: 'none', cursor: 'pointer',
                          color: '#dc2626', fontSize: '0.85rem', padding: 0,
                        }}
                        title="Remover plantão">×</button>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}

// Modal pra adicionar plantão (modo 'novo' = 1 dia, modo 'intervalo' = recorrente)
function ModalPlantaoDiario({ modo, tecnicos, onFechar, onSalvo }) {
  const [tecId, setTecId]               = useState('');
  const [data, setData]                 = useState(() => new Date().toISOString().slice(0,10));
  const [intervaloInicio, setIntervaloInicio] = useState(() => new Date().toISOString().slice(0,10));
  const [intervaloFim, setIntervaloFim] = useState(() => {
    const d = new Date(); d.setDate(d.getDate() + 7); return d.toISOString().slice(0,10);
  });
  const [diasSemana, setDiasSemana]     = useState(new Set([6, 0])); // sáb+dom default
  const [horaInicio, setHoraInicio]     = useState('18:00');
  const [horaFim, setHoraFim]           = useState('08:00');
  const [contato, setContato]           = useState('');
  const [obs, setObs]                   = useState('');
  const [salvando, setSalvando]         = useState(false);

  function toggleDia(d) {
    setDiasSemana(s => {
      const n = new Set(s);
      if (n.has(d)) n.delete(d); else n.add(d);
      return n;
    });
  }

  async function salvar() {
    if (!tecId) { alert('Escolha um técnico'); return; }
    setSalvando(true);
    try {
      if (modo === 'novo') {
        await plantoes.criar({
          tecnico_id: parseInt(tecId, 10),
          data,
          horario_inicio: horaInicio,
          horario_fim: horaFim,
          contato_emergencia: contato || null,
          observacoes: obs || null,
        });
      } else {
        await plantoes.intervalo({
          tecnico_id: parseInt(tecId, 10),
          inicio: intervaloInicio,
          fim: intervaloFim,
          dias_semana: diasSemana.size > 0 ? [...diasSemana] : undefined,
          horario_inicio: horaInicio,
          horario_fim: horaFim,
          observacoes: obs || null,
        });
      }
      onSalvo();
    } catch (e) {
      alert('Falha ao salvar: ' + (e.uiMessage || e.message));
    } finally {
      setSalvando(false);
    }
  }

  return (
    <div onClick={onFechar} style={{
      position: 'fixed', inset: 0, background: '#0008',
      display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
    }}>
      <div onClick={e => e.stopPropagation()} style={{
        background: '#fff', borderRadius: 10, padding: '1.25rem 1.5rem',
        width: 520, maxWidth: '92vw', maxHeight: '90vh', overflowY: 'auto',
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
          <h3 style={{ margin: 0 }}>
            {modo === 'novo' ? '📞 Novo plantão' : '🗓 Plantão recorrente'}
          </h3>
          <button onClick={onFechar} style={{ background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer' }}>×</button>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div>
            <label style={lblP}>Técnico</label>
            <select value={tecId} onChange={e => setTecId(e.target.value)} style={inpP}>
              <option value="">— escolha —</option>
              {tecnicos.map(t => (
                <option key={t.id} value={t.id}>
                  {t.apelido || t.nome} ({t.cidade})
                </option>
              ))}
            </select>
          </div>

          {modo === 'novo' ? (
            <div>
              <label style={lblP}>Data</label>
              <input type="date" value={data} onChange={e => setData(e.target.value)} style={inpP}/>
            </div>
          ) : (
            <>
              <div style={{ display: 'flex', gap: 10 }}>
                <div style={{ flex: 1 }}>
                  <label style={lblP}>De</label>
                  <input type="date" value={intervaloInicio} onChange={e => setIntervaloInicio(e.target.value)} style={inpP}/>
                </div>
                <div style={{ flex: 1 }}>
                  <label style={lblP}>Até</label>
                  <input type="date" value={intervaloFim} onChange={e => setIntervaloFim(e.target.value)} style={inpP}/>
                </div>
              </div>
              <div>
                <label style={lblP}>Dias da semana</label>
                <div style={{ display: 'flex', gap: 5, flexWrap: 'wrap' }}>
                  {['Dom','Seg','Ter','Qua','Qui','Sex','Sáb'].map((d, i) => (
                    <button key={i} type="button" onClick={() => toggleDia(i)}
                      style={{
                        padding: '6px 12px', borderRadius: 6, cursor: 'pointer',
                        border: '1.5px solid', fontSize: '0.8rem', fontWeight: 600,
                        borderColor: diasSemana.has(i) ? '#F15D22' : '#e5e7eb',
                        background: diasSemana.has(i) ? '#FDEBE3' : '#fff',
                        color: diasSemana.has(i) ? '#C2410C' : '#6b7280',
                      }}>
                      {d}
                    </button>
                  ))}
                </div>
                <span className="muted" style={{ fontSize: '0.7rem', marginTop: 4, display: 'block' }}>
                  {diasSemana.size === 0 ? 'Vai criar pra todos os dias do intervalo' : `Vai criar plantão nos dias: ${[...diasSemana].sort().map(d => ['dom','seg','ter','qua','qui','sex','sáb'][d]).join(', ')}`}
                </span>
              </div>
            </>
          )}

          <div style={{ display: 'flex', gap: 10 }}>
            <div style={{ flex: 1 }}>
              <label style={lblP}>Início</label>
              <input type="time" value={horaInicio} onChange={e => setHoraInicio(e.target.value)} style={inpP}/>
            </div>
            <div style={{ flex: 1 }}>
              <label style={lblP}>Fim</label>
              <input type="time" value={horaFim} onChange={e => setHoraFim(e.target.value)} style={inpP}/>
            </div>
          </div>
          <span className="muted" style={{ fontSize: '0.7rem', marginTop: -4 }}>
            Se fim &lt; início, o plantão atravessa a meia-noite (ex: 18h → 08h do dia seguinte).
          </span>

          {modo === 'novo' && (
            <div>
              <label style={lblP}>Contato de emergência (opcional)</label>
              <input type="text" value={contato} onChange={e => setContato(e.target.value)}
                placeholder="WhatsApp pessoal, etc." style={inpP}/>
            </div>
          )}

          <div>
            <label style={lblP}>Observações (opcional)</label>
            <textarea value={obs} onChange={e => setObs(e.target.value)}
              rows={2} style={{ ...inpP, resize: 'vertical' }}/>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
          <button className="btn secondary" onClick={onFechar} disabled={salvando}>Cancelar</button>
          <button className="btn" onClick={salvar} disabled={salvando}>
            {salvando ? 'Salvando...' : (modo === 'novo' ? '💾 Salvar plantão' : '🗓 Criar plantões')}
          </button>
        </div>
      </div>
    </div>
  );
}

const lblP = { fontSize: '0.75rem', fontWeight: 600, display: 'block', marginBottom: 4, color: '#374151' };
const inpP = { width: '100%', padding: '6px 10px', border: '1.5px solid #e5e7eb', borderRadius: 6, fontSize: '0.85rem' };
